import {Alert, Button, Group, Stack, Textarea} from '@mantine/core'
import {useState} from 'react'

type DidNotHappenPanelProps = {
    reportedAt: string | null | undefined
    onReport?: (note: string) => Promise<void>
}

export const DID_NOT_HAPPEN_NOTE = 'Reported as did not happen. Rep notified'

export function DidNotHappenPanel({reportedAt, onReport}: DidNotHappenPanelProps) {
    const [asking, setAsking] = useState(false)
    const [note, setNote] = useState('')
    const [saving, setSaving] = useState(false)

    if (reportedAt) {
        return (
            <Alert color="yellow" variant="light" data-testid="did-not-happen-note">
                {DID_NOT_HAPPEN_NOTE}
            </Alert>
        )
    }

    if (!onReport) {
        return null
    }

    const report = onReport

    if (!asking) {
        return (
            <Group justify="flex-end">
                <Button
                    variant="default"
                    size="xs"
                    color="red"
                    onClick={() => setAsking(true)}
                    data-testid="did-not-happen-button"
                >
                    Did not happen
                </Button>
            </Group>
        )
    }

    async function handleReport() {
        setSaving(true)
        try {
            await report(note)
            setAsking(false)
            setNote('')
        } catch {
            // Error is surfaced by the caller; the note is kept for retry.
        } finally {
            setSaving(false)
        }
    }

    return (
        <Stack gap="xs" data-testid="did-not-happen-form">
            <Textarea
                label="Note for the rep (optional)"
                placeholder="e.g. Site was closed"
                value={note}
                onChange={(event) => setNote(event.currentTarget.value)}
                autosize
                minRows={2}
            />
            <Group justify="flex-end" gap="sm">
                <Button
                    variant="subtle"
                    size="xs"
                    onClick={() => setAsking(false)}
                    disabled={saving}
                >
                    Back
                </Button>
                <Button size="xs" color="red" loading={saving} onClick={() => void handleReport()}>
                    Notify rep
                </Button>
            </Group>
        </Stack>
    )
}
